// extracted by mini-css-extract-plugin
export var cancelButton = "_nc-5";
export var content = "_nc-3";
export var createButton = "_nc-6";
export var drawerContainer = "_nc-0";
export var footer = "_nc-2";
export var header = "_nc-1";
export var orderFormColumn = "_nc-4";